<template>
  <div class="max-pharmacist-shell">
    <div class="w-view-shell" style="width: 20rem">
      <div class="pharmacist-course-shell">
        <div class="nav">
          <div>
            <h3>公需科目选择课程</h3>
            <!-- <span>交费前，请先选择课程</span> -->
          </div>
          <div></div>
        </div>
        <div class="msg">
          <div class="msg-left">
            <el-form ref="form" inline>
              <el-form-item label="执业类型" style="margin-right: 20px">
                <el-select v-model="leixing" class="picker" disabled>
                  <el-option
                    v-for="item in column"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择年份">
                <el-select
                  v-model="year"
                  placeholder="请选择"
                  @change="onChange"
                  class="picker"
                >
                  <el-option
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span>
              选课说明：关于公需科目学习要求根据人社部《专业技术人员继续教育规定》，所选课程
              <span>不少于30学时</span>，
              每学时的时长为45分钟，自由选择课程，
              <span>累计达到1350分钟</span>
              即可，
              <span>计10学分</span>。
            </span>
          </div>
          <div class="card">
            <img src="@/assets/wechat.png" alt="" />
            <div>
              按省药监局统一要求，学习中有人脸识别，如电脑无摄像设备，请扫码关注公众号进行学习考试。
            </div>
          </div>
        </div>
        <div class="course-arr">
          <div class="all_checked" v-if="show_check">
            <div :class="{check: all_checked}" @click="handleCheck">{{!all_checked ? '一键选课' : '取消选课'}}</div>
          </div>
          <div class="course-item" v-for="(item, index) in list" :key="index">
            <img :src="item.course_img" alt="">
            <div>
              <h3>{{item.course_name}}</h3>
              <span>授课老师：{{item.teacher_name}}</span>
              <span>时长：{{ item.file_time | setTime }} 分钟</span>
              <div v-if="!item.is_select" @click="cut_select(item, index)">添加</div>
              <div :class="item.is_required == 1 ? 'btn disabled' : 'btn'" v-if="item.is_select" @click="cut_select(item, index)">{{item.is_required == 1 ? '已选' : '取消'}}</div>
            </div>
          </div>
        </div>
        <div class="footer-place"></div>
        <div class="bottom-handle-pay">
          <div class="bottom-tips" >
            您所选课程需要达到1350分钟
          </div>

          <template>
            <div class="bottom-tips">
              已选<span class="num">{{ directory_ids.length }}</span>门
            </div>
            <div class="bottom-tips">
              共<span class="num">{{parseInt(file_time/60)}}</span>分钟
            </div>
          </template>
          
          <div class="pay-btn" @click="buy" :style="{'background-color': file_time < 1350*60 ? '#aaa' : ''}">开始学习</div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="30%" center>
      <div class="success">
        <h3>专属老师微信</h3>
        <p>快扫码添加你的专属老师微信</p>
        <img src="@/assets/teacher_wx.png" alt="" class="code" />
        <div>服务时间：周一至周五8:30～17；30</div>
      </div>
      <span slot="footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  name: "pharmacist-course",
  data() {
    return {
      list: [],
      directory_ids: [],
      column: [],
      leixing: "",
      info: {},
      options: [],
      year: "",
      sum_time: 0,
      file_time: 0,
      cuurrent_year: '',
      dialogVisible: false,
      all_checked: false,
      show_check: false
    };
  },
  filters: {
    setTime (value) {
      return Math.round(value/60)
    }
  },
  mounted() {
    let info = localStorage.getItem("user_info")
    this.leixing = JSON.parse(info).leixing
    if (!this.leixing) {
      this.getUserInfo()
    } else {
      this.init()
    }

    this.$nextTick(() => {
      let openNum = Number(localStorage.getItem('openNum')) || 0
      if (openNum != 2) {
        openNum++
        localStorage.setItem('openNum', openNum)
        this.dialogVisible = true
      }
    })
  },
  beforeDestroy() {
    document.getElementById('app').onscroll = ()=>{}
    window.clearInterval(this.pay_timer);
  },
  methods: {
    getUserInfo() {
      this.API.post("user/user_infos-user_info", {}).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        if (res.code == 10010) {
          let user_info = res.data.user_info
          this.leixing = user_info.leixing
          this.$store.state.user_info = user_info;
          this.$store.state.user_img = user_info.head_img_url;
          localStorage.setItem("user_id", user_info.user_id);
          localStorage.setItem("user_info", JSON.stringify(user_info));
          this.init()
        }
      });
    },
    init () {
      this.cuurrent_year = new Date().getFullYear()
      this.year = this.$route.query.year || ''
      if (Number(this.year) == this.cuurrent_year) {
        this.show_check = true
      }
      this.getTeacher()
      setTimeout(() => {
        // 设置宽度
        let w = document.getElementsByClassName('pharmacist-course-shell')[0].clientWidth
        document.getElementsByClassName('bottom-handle-pay')[0].style.width = w + 'px'
        // 获取左边距
        let left = document.getElementsByClassName('pharmacist-course-shell')[0].offsetLeft

        // 获取占位元素距离可视窗口顶部的距离
        // 滚动的距离 = 可视窗口顶部距离页面顶部的距离
        // 占位元素距离页面顶部的距离-滚动的距离= 占位元素距离可视窗口顶部的距离（pt）
        let top = document.getElementById("app").scrollTop
        let pt = document.getElementsByClassName('footer-place')[0].offsetTop
        pt = pt - top
        // 当pt大于(可视窗口高度-30)的距离时使元素悬浮
        if (pt > document.documentElement.clientHeight-50) {
          document.getElementsByClassName('bottom-handle-pay')[0].style.position = 'fixed'
          document.getElementsByClassName('bottom-handle-pay')[0].style.bottom = '30px'
          document.getElementsByClassName('bottom-handle-pay')[0].style.left = left+'px'
          document.getElementsByClassName('bottom-handle-pay')[0].style.margin = '0'
        }
        document.getElementById('app').onscroll = () => {
          let top = document.getElementById("app").scrollTop
          let pt = document.getElementsByClassName('footer-place')[0].offsetTop
          pt = pt - top
          if (pt > document.documentElement.clientHeight-50) {
            let left = document.getElementsByClassName('pharmacist-course-shell')[0].offsetLeft
            document.getElementsByClassName('bottom-handle-pay')[0].style.position = 'fixed'
            document.getElementsByClassName('bottom-handle-pay')[0].style.bottom = '30px'
            document.getElementsByClassName('bottom-handle-pay')[0].style.left = left+'px'
          } else if (pt < document.documentElement.clientHeight-50) {
            // 当pt小于(可视窗口高度-30)的距离时使元素固定
            document.getElementsByClassName('bottom-handle-pay')[0].style.position = 'relative'
            document.getElementsByClassName('bottom-handle-pay')[0].style.bottom = '0'
            document.getElementsByClassName('bottom-handle-pay')[0].style.left = '0'
          }    
        }
      }, 500)
    },
    getTeacher() {
      this.API.post("user/public_in-public_year", {}).then((res) => {
        this.info = res.data;
        this.options = res.data.year
        this.year = this.year ? this.year : (res.data.buy_year != 0 ? res.data.buy_year : res.data.year[0])
        this.getBuyStatus()
      });
    },
    onChange() {
      this.getBuyStatus()
    },
    getBuyStatus() {
      this.API.post("Home/course_out-study_end", {}).then(res => {
        if (res.data.state == 1) {
          this.$confirm('<div style="text-align:left">接省药监局通知,执业药师继续教育<span style="color:red">学习平台和报名通道</span>于2023年7月12日下午18:00起同步<span style="color:red">关闭进行系统升级</span>，预计下周同时开启。</div>', '温馨提示', {
            dangerouslyUseHTMLString: true,
            center: true,
            showCancelButton: false,
            confirmButtonText: '知道了',
          })
        } else {
          this.API.post("user/public_in-buy_status", {year: this.year}).then((res) => {
            if (res.errno == 0) {
              if (res.data.course_status) {
                this.$router.push("/PublicList?year="+this.year);
              } else {
                this.get_course_list()
              }
            }
          });
        }
      })
    },
    make(linkUrl) {
      this.$refs.qrcode.innerHTML = ""; // 防止重复生成
      let qrcode = new QRCode("qrcode", {
        width: 160,
        height: 160,
        text: linkUrl,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      console.log(qrcode);
    },
    get_course_list() {
      this.API.post("user/public_in-get_public_course", {year: this.year}).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        let file_time = 0
        let list = res.data.public_course
        for (let i = 0; i < list.length; i++) {
          if (list[i].is_required) {
            list[i].is_select = true;
            file_time = file_time + list[i].file_time
          } else {
            list[i].is_select = false;
          }
          list[i].name = list[i].course_name
          if (list[i].course_name.indexOf('（上）') != -1) {
            list[i].name = list[i].course_name.split("（上）")[0]
          }
          if (list[i].course_name.indexOf('（下）') != -1) {
            list[i].name = list[i].course_name.split("（下）")[0]
          }
        }
        file_time = file_time
        this.sum_time = file_time
        this.list = list;
        this.sum();
      });
    },
    handleCheck () {
      this.all_checked = !this.all_checked
      for (let i in this.list) {
        if (this.list[i].is_default == 1) {
          this.list[i].is_select = this.all_checked
        }
      }
      this.sum(this.all_checked);
    },
    cut_select(item, index) {
      if (item.is_required) {
        return this.API.SMessage("必选课程,不可取消");
      }
      this.list[index].is_select = !this.list[index].is_select;
      for (let v of this.list) {
        if (v.name === this.list[index].name) {
          v.is_select = this.list[index].is_select
        }
      }
      this.sum(this.list[index].is_select);
    },
    sum(type) {
      this.directory_ids = [];
      this.file_time = 0
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].is_select) {
          this.directory_ids.push(this.list[i].course_id);
          this.file_time = this.file_time + this.list[i].file_time
        }
      }
      this.file_time = this.file_time
      if (type && this.file_time > 1350*60) {
        this.$alert('您所选课时已达到1350分钟，请点击开始学习!', '提示', {
          confirmButtonText: '确认',
          closeOnPressEscape: false,
          center: true,
          roundButton: true,
          confirmButtonClass: 'alertBtn',
          customClass: 'alertFont'
        });
      }
    },
    buy() {
      if (this.file_time < 1350*60) {
        this.$alert('您所选课时未达到1350分钟，请继续选课！', '提示', {
          confirmButtonText: '确认',
          closeOnPressEscape: false,
          center: true,
          roundButton: true,
          confirmButtonClass: 'alertBtn',
          customClass: 'alertFont'
        });
        return
      }
      this.API.post("user/public_in-buy_public_course", {
        course_id: this.directory_ids.join(","),
        year:this.year,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.$router.push({ path: "/paymentOk"});
        // this.$router.push({path: '/PublicList?year=' + this.year})
      });
    },
  },
};
</script>

<style lang="less" scoped>

.max-pharmacist-shell {
  width: 100%;
  background-color: #fff;
}

.pharmacist-course-shell {
  width: 100%;
  min-height: 70vh;
  background-color: #fff;
  padding-bottom: 20px;
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 30px;
    > div {
      display: flex;
      align-items: flex-end;
      h3 {
        font-size: 1.17em;
      }
      span {
        margin-left: 10px;
        color: #2aa9b5;
      }
    }
    > div:last-child {
      font-size: 38px;
      color: red;
    }
  }
  /deep/ .el-form-item__label {
    font-weight: bold;
    color: #000000;
    font-size: 1.17em;
  }
  /deep/ .el-input__inner {
    font-size: 1.17em;
    font-weight: bold;
  }

  .msg {
    margin: 30px 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 20px;
    .msg-left {
      width: 65%;
      > span {
        display: block;
        margin-top: 20px;
        font-size: 20px;
        > span {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .card {
      display: flex;
      align-items: center;
      img {
        width: 120px;
      }
      div {
        font-size: 15px;
        margin-left: 10px;
        width: 150px;
      }
    }
  }

  .course-arr {
    display: flex;
    flex-wrap: wrap;
    .all_checked {
      width: 100%;
      display: flex;
      justify-content: end;
      margin-bottom: 20px;
      > div {
        width: 120px;
        height: 45px;
        color: #fff;
        line-height: 45px;
        text-align: center;
        cursor: pointer;
        font-size: 20px;
        border: 1px solid #2aa9b5;
        background-color: #2aa9b5;
      }
      > .check {
        border: 1px solid #ff4050;
        background-color: #ff4050;
      }
    }
    .course-item {
      margin-bottom: 20px;
      display: flex;
      width: 30%;
      margin-right: 40px;
      > img {
        width: 160px;
        height: 160px;
        margin-right: 20px;
      }
      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        h3 {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          white-space: pre-wrap;
          word-break: break-all;
          margin-bottom: 10px;
        }
        > span {
          margin-bottom: 10px;
          color: #666666;
        }
        > div {
          width: 130px;
          height: 30px;
          line-height: 30px;
          border-radius: 15px;
          border: 1px solid #2aa9b5;
          text-align: center;
          color: #2198a3;
          cursor: pointer;
          &:hover {
            background-color: rgb(48, 236, 253);
            color: #2198a3;
          }
        }
        .btn {
          background-color: #2aa9b5;
          color: #ffffff;
        }
        .disabled {
          border: #aaa;
          background-color: #aaa;
          &:hover {
            background-color: #aaa;
            color: #fff;
          }
        }
      }
    }
  }
}

.bottom-handle-pay {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100px;
  border-radius: 50px;
  padding: 0 20px;
  background: #eeeeee;
  border: 1px solid #2198a3;

  .bottom-tips {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-right: 20px;
    .num {
      text-decoration: underline;
      display: inline-block;
      padding: 0 10px;
      color: red;
    }
  }

  .total-price {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-right: 20px;
  }

  .pay-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: red;
    border-radius: 10px;
    font-size: 26px;
    font-family: PingFang SC;
    padding: 10px 15px;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
  }

  .price,
  .num {
    color: rgba(216, 37, 28, 1);
    font-size: 34px;
  }
}

.success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h3 {
    margin: 25px 0;
    font-size: 24px;
  }
  p {
    color: #666666;
    margin-bottom: 25px;
    font-size: 18px;
    text-align: center;
  }
  .code {
    width: 180px;
    margin: 0 0 40px;
  }
}
</style>
